import {
  FAILED_OR_BANNED_STATUS_COLOR,
  IN_PROGRESS_STATUS_COLOR,
  READY_STATUS_COLOR,
} from "./components/TradedAccountsInfoTableColumns/utils";
import { FilterOption } from "../../components/ui/FilterSearch";

export const FUNDED_TRADERS_FILTER_OPTIONS: FilterOption[] = [
  { key: "id", label: "Account id" },
  { key: "email", label: "Email" },
  { key: "name", label: "Name" },
];

export const FORCED_TO_LIVE_ACCOUNTS_OPTIONS: FilterOption[] = [
  { key: "id", label: "Account id" },
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  {
    key: "withdrawals",
    label: "Withdrawals",
    type: "number",
    subOptions: [
      { key: "more_than", label: "More than", displayLabel: "more than" },
      { key: "less_than", label: "Less than", displayLabel: "less than" },
      { key: "equal", label: "Equal", displayLabel: "equal to" },
    ],
  },
];

export const FUNDED_TRADER_STATUS = {
  recentPasser: {
    color: "rgba(235, 109, 44, 0.61)",
    name: "Forced to live",
    backgroundColor: "transparent",
    border: `1px solid ${FAILED_OR_BANNED_STATUS_COLOR}`,
  },
};

export const STATUSES_COLORS = {
  recentPasser: {
    color: READY_STATUS_COLOR,
    name: "Ready",
  },
  duplicate: {
    color: IN_PROGRESS_STATUS_COLOR,
    name: "Not ready",
  },
};
